
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":".5em","viewBox":"0 0 16 8","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.999 2.183c.416.373.7.955.7 1.81 0 .023.002.044.004.066a.668.668 0 00-.003.065c0 .643-.252 1.088-.656 1.391-.428.32-1.078.518-1.902.518-.735 0-1.285-.254-1.834-.681-.383-.299-.722-.641-1.112-1.036l-.337-.34.268-.318c.433-.516.804-.957 1.214-1.323.55-.49 1.09-.762 1.801-.762.798 0 1.43.227 1.857.61zM16 3.993a.668.668 0 01-.003.066.668.668 0 01.003.065c0 1.043-.436 1.877-1.177 2.432-.718.538-1.671.777-2.68.777-1.099 0-1.923-.401-2.634-.955-.446-.348-.889-.794-1.321-1.23L8 4.957l-.188.19c-.432.436-.875.882-1.32 1.23-.712.554-1.536.955-2.634.955-1.01 0-1.963-.239-2.681-.777C.437 6.001 0 5.166 0 4.124c0-.022.001-.044.003-.065A.658.658 0 010 3.994c0-1.168.402-2.122 1.132-2.778.72-.647 1.69-.944 2.726-.944 1.125 0 1.969.472 2.685 1.112.491.44.964 1 1.43 1.556l.03.034c.02-.025.04-.05.062-.075.462-.55.927-1.103 1.41-1.534.71-.633 1.546-1.093 2.667-1.093 1.036 0 2.006.297 2.726.944.73.656 1.132 1.61 1.132 2.778zm-8.856-.02l-.23-.272c-.44-.522-.82-.974-1.238-1.347-.561-.503-1.11-.781-1.818-.781-.798 0-1.43.227-1.857.61-.416.373-.7.955-.7 1.81a.659.659 0 01-.004.066.659.659 0 01.003.065c0 .643.251 1.088.656 1.391.428.32 1.078.518 1.902.518.735 0 1.285-.254 1.834-.681.383-.299.722-.641 1.112-1.036.109-.11.221-.224.34-.342z"}})])
          )
        }
      }
    